/*
    This script is meant to run on unsupported browsers.
    We can therefore not use React, Babel transpilation
    or modern browser features.
*/

var minBrowserVersions = {
  chrome: '120',
  edge: '117',
  firefox: '115',
  ie: '12',
  opera: '103',
  safari: '17.6',
};

function showUpgradeModal() {
  if (document.getElementById('outdated')) {
    return;
  }

  var upgradeHref = 'https://browsehappy.com/?locale=en';

  // Inject keyframe animation via a <style> tag (old browsers just ignore it)
  var styleEl = document.createElement('style');
  styleEl.type = 'text/css';
  var css =
    '@-webkit-keyframes bk-slide-down{from{opacity:0;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}' +
    '@keyframes bk-slide-down{from{opacity:0;transform:translateY(-100%)}to{opacity:1;transform:translateY(0)}}';
  if (styleEl.styleSheet) {
    // IE < 9
    styleEl.styleSheet.cssText = css;
  } else {
    styleEl.appendChild(document.createTextNode(css));
  }
  (document.head || document.getElementsByTagName('head')[0]).appendChild(
    styleEl
  );

  var banner = document.createElement('div');
  banner.setAttribute('id', 'outdated');
  banner.setAttribute(
    'style',
    'position:relative;' +
      'width:100%;' +
      'background:#1a1a2e;' +
      'color:#fff;' +
      'z-index:99999 !important;' +
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;' +
      '-webkit-animation:bk-slide-down .3s ease;animation:bk-slide-down .3s ease;'
  );

  var inner = document.createElement('div');
  inner.setAttribute(
    'style',
    'max-width:960px;' +
      'margin:0 auto;' +
      'padding:12px 16px;' +
      'display:-webkit-box;display:-ms-flexbox;display:flex;' +
      '-webkit-box-align:center;-ms-flex-align:center;align-items:center;' +
      '-ms-flex-wrap:wrap;flex-wrap:wrap;' +
      'gap:8px 16px;'
  );

  // Warning icon
  var iconWrap = document.createElement('div');
  iconWrap.setAttribute(
    'style',
    'width:28px;height:28px;' +
      '-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;' +
      'display:-webkit-box;display:-ms-flexbox;display:flex;' +
      '-webkit-box-align:center;-ms-flex-align:center;align-items:center;' +
      '-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;'
  );
  iconWrap.innerHTML =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" ' +
    'stroke="#ffb74d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var text = document.createElement('span');
  text.setAttribute(
    'style',
    'font-size:14px;' +
      'line-height:1.4;' +
      '-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;'
  );
  text.appendChild(
    document.createTextNode(
      'Your browser is out of date and may not support all features.'
    )
  );

  var actions = document.createElement('span');
  actions.setAttribute(
    'style',
    'display:-webkit-box;display:-ms-flexbox;display:flex;' +
      'gap:8px;' +
      '-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;' +
      '-webkit-box-align:center;-ms-flex-align:center;align-items:center;'
  );

  var upgradeBtn = document.createElement('a');
  upgradeBtn.setAttribute('href', upgradeHref);
  upgradeBtn.setAttribute('target', '_blank');
  upgradeBtn.setAttribute('rel', 'noopener noreferrer');
  upgradeBtn.setAttribute(
    'style',
    'display:inline-block;' +
      'padding:6px 16px;' +
      'background:#fff;' +
      'color:#1a1a2e;' +
      'font-size:13px;' +
      'font-weight:600;' +
      'border:none;' +
      'border-radius:6px;' +
      'cursor:pointer;' +
      'text-decoration:none;' +
      'white-space:nowrap;'
  );
  upgradeBtn.appendChild(document.createTextNode('Update browser'));

  var dismissBtn = document.createElement('button');
  dismissBtn.setAttribute('type', 'button');
  dismissBtn.setAttribute(
    'style',
    'display:inline-block;' +
      'padding:6px 12px;' +
      'background:none;' +
      'color:rgba(255,255,255,.6);' +
      'color:#aaa;' + // fallback
      'font-size:13px;' +
      'font-weight:500;' +
      'border:none;' +
      'cursor:pointer;' +
      'white-space:nowrap;' +
      'font-family:inherit;'
  );
  dismissBtn.appendChild(document.createTextNode('Dismiss'));
  dismissBtn.onclick = function () {
    var el = document.getElementById('outdated');
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  };

  actions.appendChild(upgradeBtn);
  actions.appendChild(dismissBtn);
  inner.appendChild(iconWrap);
  inner.appendChild(text);
  inner.appendChild(actions);
  banner.appendChild(inner);

  // Insert at the top of <body> so it doesn't overlay page content
  if (document.body.firstChild) {
    document.body.insertBefore(banner, document.body.firstChild);
  } else {
    document.body.appendChild(banner);
  }
}

if (typeof window !== 'undefined') {
  var browser = (function () {
    var ua = window.navigator.userAgent;
    var tem;
    var M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'ie', version: tem[1] || '' };
    } else if (/MSIE/i.test(M[1])) {
      return { name: 'ie', version: M[2] || '' };
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/);

      if (tem != null) {
        return { name: 'opera', version: tem[1] };
      }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+(?:\.\d+)?)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }

    return {
      name: M[0].toLowerCase(),
      version: M[1],
    };
  })();

  var minVersion = minBrowserVersions[browser['name']];
  var isUnsupportedBrowser =
    minVersion && parseFloat(browser['version']) < parseFloat(minVersion);
  var hasMissingBrowserAPIs =
    !window.URL || !window.Proxy || !window.fetch || !window.Map;
  var isOutdated = isUnsupportedBrowser || hasMissingBrowserAPIs;

  window['isOutdated'] = isOutdated;
  window['showUpgradeModal'] = showUpgradeModal;

  if (isOutdated) {
    addLoadEvent(showUpgradeModal);

    function addLoadEvent(func) {
      var oldonload = window.onload;
      if (typeof window.onload !== 'function') {
        window.onload = func;
      } else {
        window.onload = function () {
          if (oldonload) {
            // @ts-ignore
            oldonload();
          }
          func();
        };
      }
    }
  }
}
